module.exports = __webpack_public_path__ + "img/icon343.b3ba89d4.png";